/* eslint-disable max-lines-per-function, import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React, { useState, useRef, useEffect } from "react";
import { cn } from "tailwind-variants";
import { useDtfStore } from "../store";
import AreasOfInterestOverlay from "./AreasOfInterestOverlay.vue";
import { PIN_COLORS } from "./composables/usePinningPanel";
import {
  trackPinSessionsGenPreviewBeforeClicked,
  trackPinSessionsGenPreviewAfterClicked
} from "./transfersPinningAnalytics";
import "./PinningArtboard.scss";
import { renderList } from "common/vue/render-list";

export default function PinningArtboard({
  imageUrl,
  generatedImageUrl = "",
  pins = [],
  activePinId = null,
  hoveredPinId = null,
  showPins = true,
  isShowingEditPreview = false,
  canAddPin = true,
  zoom = 1,
  showTooltip = false,
  tooltipMessage = "",
  isDesktop = false,
  isFeedbackVisible = false,
  sessionId = "",
  artworkId = "",
  onAddPin,
  onPinClick,
  onPinHover,
  onPinUnhover,
  onTooltipDismiss,
  onImageLoaded,
  ...restProps
}: any) {
  const store = useDtfStore();
  const containerRef = useRef(null);
  const imageRef = useRef(null);
  const resizeObserverRef = useRef(null);

  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageRect, setImageRect] = useState({
    width: 0,
    height: 0,
    left: 0,
    top: 0
  });
  const [naturalWidth, setNaturalWidth] = useState(0);
  const [naturalHeight, setNaturalHeight] = useState(0);
  const [beforeAfterView, setBeforeAfterViewState] = useState("after");

  function setBeforeAfterView(view: any) {
    setBeforeAfterViewState(view);
    if (!sessionId || !artworkId) return;
    const payload = { artworkId, sessionId, generatedImageUrl };
    if (view === "before") {
      trackPinSessionsGenPreviewBeforeClicked(payload);
    } else {
      trackPinSessionsGenPreviewAfterClicked(payload);
    }
  }

  useEffect(() => {
    if (isShowingEditPreview) setBeforeAfterViewState("after");
  }, [isShowingEditPreview]);

  function displayImageUrl() {
    return isShowingEditPreview && beforeAfterView === "after" && generatedImageUrl
      ? generatedImageUrl
      : imageUrl;
  }

  function sortedPins() {
    return (
      pins
        // @ts-expect-error TS(7006): Parameter 'pin' implicitly has an 'any' type.
        .map((pin, index) => ({
          ...pin,
          originalIndex: index
        }))
        // @ts-expect-error TS(7006): Parameter 'a' implicitly has an 'any' type.
        .sort((a, b) => {
          if (a.id === activePinId) return 1;
          if (b.id === activePinId) return -1;
          return 0;
        })
    );
  }

  function backgroundClass() {
    // @ts-expect-error TS(4111): Property 'backgroundType' comes from an index sign... Remove this comment to see the full error message
    if (store.backgroundType === "green") {
      return "pinning-artboard--green";
    }
    return "pinning-artboard--checkered";
  }

  function isHoveringCompletedPin() {
    if (!hoveredPinId) return false;
    // @ts-expect-error TS(7006): Parameter 'p' implicitly has an 'any' type.
    const hoveredPin = pins.find(p => p.id === hoveredPinId);
    return hoveredPin?.state === "ready" || hoveredPin?.state === "unsupported";
  }

  function pinsWithAreasOfInterest() {
    return pins.filter(
      // @ts-expect-error TS(7006): Parameter 'p' implicitly has an 'any' type.
      p => p.areasOfInterest && p.areasOfInterest.objects && p.areasOfInterest.objects.length > 0
    );
  }

  function isOverlayVisible(pin: any) {
    const isCompleted = pin.state === "ready" || pin.state === "unsupported";
    if (isCompleted) {
      return hoveredPinId === pin.id;
    }
    return pin.highlightAreasEnabled !== false && !isHoveringCompletedPin();
  }

  function updateImageRect() {
    const img = imageRef.current;
    const container = containerRef.current;
    if (!img || !container) return;
    // @ts-expect-error TS(2339): Property 'getBoundingClientRect' does not exist on... Remove this comment to see the full error message
    const containerRect = container.getBoundingClientRect();
    // @ts-expect-error TS(2339): Property 'getBoundingClientRect' does not exist on... Remove this comment to see the full error message
    const imgRect = img.getBoundingClientRect();
    const z = zoom > 0 ? zoom : 1;
    const baseWidth = imgRect.width / z;
    const baseHeight = imgRect.height / z;
    const widthDelta = imgRect.width - baseWidth;
    const heightDelta = imgRect.height - baseHeight;
    setImageRect({
      width: baseWidth,
      height: baseHeight,
      left: imgRect.left - containerRect.left + widthDelta / 2,
      top: imgRect.top - containerRect.top + heightDelta / 2
    });
  }

  function onImageLoad() {
    const img = imageRef.current;
    if (img) {
      // @ts-expect-error TS(2339): Property 'naturalWidth' does not exist on type 'ne... Remove this comment to see the full error message
      setNaturalWidth(img.naturalWidth);
      // @ts-expect-error TS(2339): Property 'naturalHeight' does not exist on type 'n... Remove this comment to see the full error message
      setNaturalHeight(img.naturalHeight);
    }
    setImageLoaded(true);
    updateImageRect();
    if (isShowingEditPreview && beforeAfterView === "after") {
      onImageLoaded?.();
    }
  }

  function handleContainerClick(e: any) {
    if (!canAddPin || !imageLoaded) return;
    const container = containerRef.current;
    if (!container) return;
    // @ts-expect-error TS(2339): Property 'getBoundingClientRect' does not exist on... Remove this comment to see the full error message
    const containerRect = container.getBoundingClientRect();
    const z = zoom > 0 ? zoom : 1;
    const baseWidth = imageRect.width;
    const baseHeight = imageRect.height;
    if (baseWidth <= 0 || baseHeight <= 0) return;
    const displayWidth = baseWidth * z;
    const displayHeight = baseHeight * z;
    if (displayWidth <= 0 || displayHeight <= 0) return;
    const displayLeft = imageRect.left - (displayWidth - baseWidth) / 2;
    const displayTop = imageRect.top - (displayHeight - baseHeight) / 2;
    const relX = (e.clientX - containerRect.left - displayLeft) / displayWidth;
    const relY = (e.clientY - containerRect.top - displayTop) / displayHeight;
    if (relX < 0 || relX > 1 || relY < 0 || relY > 1) return;
    const nw = naturalWidth;
    const nh = naturalHeight;
    if (nw <= 0 || nh <= 0) return;
    const x = Math.min(Math.max(Math.round(relX * nw), 0), Math.max(nw - 1, 0));
    const y = Math.min(Math.max(Math.round(relY * nh), 0), Math.max(nh - 1, 0));
    onAddPin?.({
      x,
      y
    });
  }

  useEffect(() => {
    if (containerRef.current) {
      // @ts-expect-error TS(2322): Type 'ResizeObserver' is not assignable to type 'n... Remove this comment to see the full error message
      resizeObserverRef.current = new ResizeObserver(() => {
        updateImageRect();
      });
      // @ts-expect-error TS(2531): Object is possibly 'null'.
      resizeObserverRef.current.observe(containerRef.current);
    }
    return () => {
      if (resizeObserverRef.current) {
        // @ts-expect-error TS(2339): Property 'disconnect' does not exist on type 'neve... Remove this comment to see the full error message
        resizeObserverRef.current.disconnect();
        resizeObserverRef.current = null;
      }
    };
  }, []);

  const paddingValue = isDesktop ? `60px 16px ${isFeedbackVisible ? "140px" : ""}` : "10px";

  return (
    <div
      {...restProps}
      className={cn(
        "scope-abbec8e3 relative flex h-full w-full cursor-crosshair items-center justify-center overflow-hidden",
        backgroundClass()
      )}
      ref={containerRef}
      style={{
        padding: paddingValue
      }}
      data-testid="pinning-artboard-container"
      onClick={handleContainerClick}
    >
      <img
        className="scope-abbec8e3 pointer-events-none block max-h-full max-w-full select-none object-contain"
        ref={imageRef}
        src={displayImageUrl()}
        alt="Artwork"
        draggable="false"
        data-testid="pinning-artboard-image"
        style={{
          transform: `scale(${zoom})`,
          transformOrigin: "center center"
        }}
        onLoad={onImageLoad}
      />
      {isShowingEditPreview ? (
        <div
          className="absolute left-1/2 top-3 z-20 flex -translate-x-1/2 overflow-hidden rounded-full bg-white p-1 shadow-md"
          data-testid="before-after-toggle"
          onClick={e => e.stopPropagation()}
        >
          <button
            type="button"
            data-testid="before-after-toggle-before"
            className={cn(
              "rounded-full px-4 py-1 text-sm font-medium transition-colors",
              beforeAfterView === "before"
                ? "bg-gray-900 !text-white"
                : "text-gray-600 hover:text-gray-900"
            )}
            onClick={() => setBeforeAfterView("before")}
          >
            Before
          </button>
          <button
            type="button"
            data-testid="before-after-toggle-after"
            className={cn(
              "rounded-full px-4 py-1 text-sm font-medium transition-colors",
              beforeAfterView === "after"
                ? "bg-gray-900 !text-white"
                : "text-gray-600 hover:text-gray-900"
            )}
            onClick={() => setBeforeAfterView("after")}
          >
            After
          </button>
        </div>
      ) : null}
      {imageRect.width > 0 ? (
        <div
          className="scope-abbec8e3 pointer-events-none absolute"
          style={{
            width: `${imageRect.width}px`,
            height: `${imageRect.height}px`,
            left: `${imageRect.left}px`,
            top: `${imageRect.top}px`,
            transform: `scale(${zoom})`,
            transformOrigin: "center center"
          }}
        >
          {!isShowingEditPreview ? (
            <>
              {renderList(pinsWithAreasOfInterest(), pin => (
                <AreasOfInterestOverlay
                  className="scope-abbec8e3"
                  key={`aoi-${pin.id}`}
                  areasOfInterest={pin.areasOfInterest}
                  naturalWidth={naturalWidth}
                  naturalHeight={naturalHeight}
                  isVisible={isOverlayVisible(pin)}
                  pinId={pin.id}
                  segmentationMaskUrl={pin.segmentationMaskUrl}
                  data-testid="areas-of-interest-overlay"
                />
              ))}
              {showPins ? (
                <>
                  {renderList(sortedPins(), pin => (
                    <div
                      className={cn(
                        "scope-abbec8e3",
                        "pointer-events-auto absolute z-[5] flex h-6 w-6 -translate-x-1/2 -translate-y-1/2 cursor-pointer select-none items-center justify-center rounded-full border-[1.5px] border-white text-[11px] font-bold leading-none text-white transition-opacity duration-150",
                        "shadow-[0_1px_4px_rgba(0,0,0,0.25)]",
                        pin.id === activePinId && "z-10",
                        activePinId && pin.id !== activePinId && "opacity-40",
                        pin.state === "processing" && "animate-pulse"
                      )}
                      key={pin.id}
                      style={{
                        left: `${(pin.coordinates.x / naturalWidth) * 100}%`,
                        top: `${(pin.coordinates.y / naturalHeight) * 100}%`,
                        backgroundColor: PIN_COLORS[pin.originalIndex % PIN_COLORS.length]
                      }}
                      data-testid={`pinning-artboard-pin-${pin.originalIndex + 1}`}
                      onClick={e => {
                        e.stopPropagation();
                        onPinClick?.(pin.id);
                      }}
                      onMouseEnter={() => {
                        onPinHover?.(pin.id);
                      }}
                      onMouseLeave={() => {
                        onPinUnhover?.();
                      }}
                    >
                      {pin.originalIndex + 1}
                    </div>
                  ))}
                </>
              ) : null}
            </>
          ) : null}
        </div>
      ) : null}
      {showTooltip ? (
        <div
          className="scope-abbec8e3 absolute left-1/2 top-[40%] z-[15] -translate-x-1/2 -translate-y-full"
          data-testid="pinning-artboard-tooltip"
          onClick={e => {
            e.stopPropagation();
          }}
        >
          <div className="scope-abbec8e3 relative flex max-w-[260px] items-center gap-2 rounded-lg border border-blue-600 bg-blue-600 px-4 py-2.5 text-center text-sm text-white shadow-[0_4px_12px_rgba(0,0,0,0.2)]">
            <span className="scope-abbec8e3">{tooltipMessage}</span>
            <button
              className="scope-abbec8e3 cursor-pointer border-none bg-transparent p-0 text-lg leading-none text-white opacity-80 hover:opacity-100"
              type="button"
              onClick={e => {
                e.stopPropagation();
                onTooltipDismiss?.();
              }}
              data-testid="cursor-pointer"
            >
              {" "}
              ×{" "}
            </button>
          </div>
          {}
          <div className="scope-abbec8e3 flex justify-center">
            <div className="scope-abbec8e3 h-0 w-0 border-x-[8px] border-t-[8px] border-x-transparent border-t-blue-600" />
          </div>
        </div>
      ) : null}
    </div>
  );
}
